import { render } from "./TermsPage.vue?vue&type=template&id=23088356&scoped=true"
import script from "./TermsPage.vue?vue&type=script&lang=js"
export * from "./TermsPage.vue?vue&type=script&lang=js"

import "./TermsPage.vue?vue&type=style&index=0&id=23088356&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23088356"]])

export default __exports__